module.exports = __webpack_public_path__ + "img/box_driving.77bae866.svg";